import removeConversationData from "./helpers/removeConversationData";
import removeItemData from "./helpers/removeItemData";
import { setSelectionOnRow } from "owa-mail-actions/lib/setSelectionOnRow";
import type TableView from "owa-mail-list-store/lib/store/schema/TableView";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";

export default function removeRowData(rowKey: string, tableView: TableView): void {
    // 1. If the row being removed is selected, remove item from selected item ids.
    // This should be done before we delete tableRowRelationKey as this sets
    // isSelected property on it.
    if (tableView.selectedRowKeys.has(rowKey)) {
        setSelectionOnRow(rowKey, tableView.id, false /* shouldSelect */); // this is a mutator
    }
    
    // 2. Remove the row data
    switch (tableView.tableQuery.listViewType) {
        case 0:
            removeConversationData(rowKey, tableView); // this calls a mutators
            break;
        
        case 1:
            removeItemData(rowKey, tableView); // this calls a mutator
            break;
    }
}
